import React, {Component} from 'react'
import PropTypes from 'prop-types'

import Registry from '../../../registry/index';

class ChatEditorUploadedAttachmentList extends Component {
    delete(attachment) {
        let siteInterface = Registry.get('siteInterface');

        var that = this;

        siteInterface.attachmentDelete(attachment)
            .then(function() {
                //that._onAttachmentDeleted(attachment)
                if (that.props.onDelete) {
                    that.props.onDelete(attachment)
                }
            })
            .catch();
    }

    _onAttachmentDeleted(attachment) {
        this.props.dispatch({type: 'ATTACHMENT_DELETED', id: attachment.id});
    }

    getItem(attachment) {
        return (
            <div className="attachment" key={attachment.id}>
                <div className="img"><img src={attachment.url} alt="img"/></div>
                <div className="delete" onClick={() => this.delete(attachment)}>&times;</div>
            </div>
        )
    }

    render() {
        let {editorAttachments, error} = this.props;

        return (
            <div className="attachments-upload" id="chatAttachmentList-room_input">
                {editorAttachments.map((editorAttachment) => this.getItem(editorAttachment))}
                {error && <div className="error">{error}</div>}
            </div>
        )
    }

}

ChatEditorUploadedAttachmentList.defaultProps = {
    editorAttachments: []
};

ChatEditorUploadedAttachmentList.propTypes = {
    editorAttachments: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        editorAttachments: state.editorAttachments
    }
}

export default ChatEditorUploadedAttachmentList;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatEditorUploadedAttachmentList/index.js